import { SET_IS_AUTHENTICATED, SET_PROFILE } from 'store/types/auth';

export const setIsAuthenticated = (isAuthenticated) => {
  return {
    type: SET_IS_AUTHENTICATED,
    payload: isAuthenticated,
  };
};

export const setProfile = (profile) => {
  return {
    type: SET_PROFILE,
    payload: profile,
  };
};
